import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Grid, Header, List, Segment } from 'semantic-ui-react'
import Contact from 'shared/Contact'

export default function RecentSection() {
    const { isReadingRecentRecords, recentRecords } = useSelector(state => ({
        isReadingRecentRecords: state.user_dashboard.ReadingRecentRecords,
        recentRecords: state.user_dashboard.recentRecords,
    }))
    return (
        <Grid centered>
            <Grid.Row columns={3}>
                <Grid.Column>
                    <Segment loading={isReadingRecentRecords}>

                        <Header as='h3' color="primary">
                            Recent Contacts
                        </Header>
                        {
                            recentRecords?.contact?.map((contact) => <List key={contact.id}>
                                <Contact
                                    contact={{ ...contact }}
                                    name={contact.name}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${contact.id}`}>{contact.name}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>
                <Grid.Column>
                    <Segment loading={isReadingRecentRecords}>

                        <Header as='h3' color="primary">
                            Recent Leads
                        </Header>
                        {
                            recentRecords?.lead?.map((lead) => <List key={lead.id}>
                                <Contact
                                    contact={{ ...lead }}
                                    name={lead.name}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${lead.id}`}>{lead.name}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>

                <Grid.Column>
                    <Segment loading={isReadingRecentRecords}>
                        <Header as='h3' color="primary">
                            Recent Opportunities
                        </Header>
                        {
                            recentRecords?.opportunities?.map((opportunity) => <List key={opportunity.id}>
                                <Contact
                                    contact={{ ...opportunity }}
                                    name={opportunity.name}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${opportunity.id}`}>{opportunity.name}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}
